module.exports = __webpack_public_path__ + "static/media/FAST-NU-logo.7a81b5df.png";